import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorRedeem = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M13 10.05a.75.75 0 1 0 0-1.5H8.5a2.75 2.75 0 0 0-2.75 2.75v7.222l-2.22-2.22a.75.75 0 0 0-1.06 1.061l3.477 3.477a.75.75 0 0 0 1.06 0l3.477-3.477a.75.75 0 0 0-1.06-1.06L7.25 18.477V11.3c0-.69.56-1.25 1.25-1.25H13Z"
    />
    <path
      fill="#F7A600"
      d="M19.053 2.77a.75.75 0 0 0-1.061 0l-3.477 3.476a.75.75 0 0 0 1.06 1.061l2.175-2.174V12.3c0 .69-.56 1.25-1.25 1.25H12a.75.75 0 0 0 0 1.5h4.5a2.75 2.75 0 0 0 2.75-2.75V5.088l2.219 2.22a.75.75 0 0 0 1.06-1.062L19.053 2.77Z"
    />
  </svg>
);
export default SvgTwoColorRedeem;
